import { ContentManagerModule } from '@2sic.com/sxc-angular';
import { Component, inject, input } from '@angular/core';
import { Categories, DownloadCategory, Driver } from '../downloadsModel';
import { ToolbarHelperService } from '../toolbar-helper.service';

@Component({
  selector: 'app-simple-download',
  imports: [ContentManagerModule],
  templateUrl: './simple-download.component.html',
  styleUrl: './simple-download.component.scss',
})
export class SimpleDownloadComponent {
  toolbarHelperSvc = inject(ToolbarHelperService);

  downloadCategory = DownloadCategory;

  items = input.required<Driver[]>();
  categoryInfo = input.required<Categories>();
  title = input<string>();

  notesBefore = input<string>();
  notesAfter = input<string>();


}
